import { useSelector } from 'react-redux'
import { DeserveDataModalInterface } from '../../../Interfaces/DeserveModalInterface'
import { RaytebRequests } from '../../../_services'
import useFetch from '../../../_services/fetch'
import { TextBoxTypeEnum } from '../../../enums/TextBoxTypeEnum'
import {
  Button,
  RaytebForm,
  Select,
  TextBox,
  TypeaheadText,
} from '../../Elements'
import LoadingFit from '../Loading/LoadingFit'
import RaytebModal from './RaytebModal'
import { ReducerType } from '../../../storeManager/ReducerType'
import { LoginInterface } from '../../../Interfaces/LoginInterface'
import { NewAppointmentModalInterface } from '../../../Interfaces/NewAppointmentModalInterface'
import React, { useState } from 'react'
import { PartialDeserveViewModel } from '../../../models/ViewModels/PartialDeserveViewMode'
import { ErrorTypeEnum } from '../../../_services/ResponseErrorType'
import { toast } from 'react-toastify'

export type DoctorShiftType = {
  key?: string | null
  value?: string | null
}
const NewAppointmentModal = ({
  option,
  doctorServeShifts,
}: {
  option: NewAppointmentModalInterface
  doctorServeShifts: Array<DoctorShiftType> | undefined
}) => {
  const user = useSelector<ReducerType, LoginInterface>(
    (state) => state.reducerUser
  )
  const center = useSelector<ReducerType, CenterViewModel>(
    (state) => state.reducerCenter
  )

  const [doctorServeShift, setDoctorServeShift] = useState<DoctorShiftType>({})

  const { isLoading, reFetch } = useFetch<DeserveDataModalInterface, Object>({
    request: RaytebRequests.Appointment_Deserve_POST({
      headers: { centerId: center.id },
      token: user?.token,
    }),
    onSuccess(data) {
      option.setDeserveModal({
        ...option.deserveModal,
        isOpen: true,
        showFooter: true,
        data: data,
        doctorServeShift: doctorServeShift.key!,
      })
      data.messages?.forEach((n) => {
        if (n.flag === ErrorTypeEnum.Error) toast.error(n.message)
        else if (n.flag === ErrorTypeEnum.Info) toast.info(n.message)
        else if (n.flag === ErrorTypeEnum.Warning) toast.warn(n.message)
        else toast.info(n.message)
      })
      setTimeout(() => {
        option.hideModal()
      }, 300)
    },
    onStatusCode201(data) {
      const dataType = data as PartialDeserveViewModel
      option.setPartialDeserveModal({
        ...option.partialDeserveModal,
        isOpen: true,
        data: dataType,
        doctorServeShift: doctorServeShift.key!,
      })
      setTimeout(() => {
        option.hideModal()
      }, 300)
    },
  })
  return (
    <>
      <RaytebModal
        isOpen={option.isOpen}
        className={'relative md:h-[350px]'}
        title='نوبت جدید'
        hideModal={() => option.hideModal()}
      >
        <LoadingFit isLoading={isLoading} />
        <RaytebForm
          checkIsRequired={true}
          onSubmit={(e) => {
            reFetch({
              PatientCode: e.target[0].value,
              Mobile: e.target[1].value,
            })
          }}
          className='w-full grid grid-cols-1 justify-items-center items-center gap-8 xs:px-10 md:px-3 p-3'
        >
          <TextBox
            Type={TextBoxTypeEnum.Text}
            innerText='کد ملی'
            className='w-full'
            isRequired={true}
            name='PersonCode'
          />
          <TextBox
            Type={TextBoxTypeEnum.Mobile}
            innerText='موبایل'
            className='w-full'
            Regular='^(09[0-9]{1,9})$'
            RxgMessage='موبایل به درستی وارد نشده است'
            isRequired={true}
            name='Mobile'
          />
          <TypeaheadText<DoctorShiftType>
            innerText='شیفت / خدمت'
            className='w-full'
            isRequired={true}
            listData={doctorServeShifts}
            fieldItem='value'
            fieldValue='key'
            selected={(e) => {
              setDoctorServeShift(e)
            }}
          ></TypeaheadText>
          <div className='mt-2 flex justify-center items-center  gap-5 w-full'>
            <Button
              onClick={() => option.hideModal()}
              className='!border-2 !px-7 border-dangerLight !bg-danger !text-white
             !text-xs !w-full h-9 !shadow-lg'
            >
              انصراف
            </Button>
            <Button
              type='submit'
              className='!border-2 border-secondaryLight !px-9 !bg-secondary !text-white
             !text-xs !w-full h-9 !shadow-lg'
            >
              تایید
            </Button>
          </div>
        </RaytebForm>
      </RaytebModal>
    </>
  )
}

export default React.memo(NewAppointmentModal)
